module.exports = "<tb-custom-query result=\"$ctrl.result\"></tb-custom-query>\n<div id=\"graphiql\">Loading...</div>";